"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCss = useCss;
var _react = require("react");
var _scopedComponent = require("./scoped.component.js");
var _styleElementUtils = require("./style-element-utils.js");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function useCss(css, overrideNamespace) {
  var isPreBuiltCss = _typeof(css) === "object";
  if (isPreBuiltCss && !(css.id && typeof css.styles === "string")) {
    throw Error("Kremling's \"useCss\" hook requires \"id\" and \"styles\" properties when using the kremling-loader");
  }
  var namespace = overrideNamespace || isPreBuiltCss && css.namespace || _scopedComponent.Scoped.defaultNamespace;
  var _useState = (0, _react.useState)(function () {
      return getStyleElement(isPreBuiltCss, css, namespace);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    styleElement = _useState2[0],
    setStyleElement = _useState2[1];
  (0, _react.useLayoutEffect)(function () {
    var newStyleElement = getStyleElement(isPreBuiltCss, css, namespace);
    setStyleElement(newStyleElement);
    newStyleElement.kremlings++;
    return function () {
      if (--styleElement.kremlings === 0) {
        var rawCss = isPreBuiltCss ? css.styles : css;
        document.head.removeChild(styleElement);
        delete _styleElementUtils.styleTags[rawCss];
      }
    };
  }, [css, namespace, isPreBuiltCss]);
  return _defineProperty({}, styleElement.kremlingAttr, String(styleElement.kremlingValue).toString());
}
function getStyleElement(isPreBuiltCss, css, namespace) {
  var kremlingAttr = isPreBuiltCss ? namespace : "data-".concat(namespace);
  var kremlingValue = isPreBuiltCss ? css.id : (0, _styleElementUtils.incrementCounter)();
  var styleElement = isPreBuiltCss ? _styleElementUtils.styleTags[css.styles] : _styleElementUtils.styleTags[css];
  if (!styleElement) {
    var kremlingSelector = "[".concat(kremlingAttr, "='").concat(kremlingValue, "']");
    var rawCss = isPreBuiltCss ? css.styles : css;
    var cssToInsert = isPreBuiltCss ? css.styles : (0, _styleElementUtils.transformCss)(css, kremlingSelector);
    styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.textContent = cssToInsert;
    styleElement.kremlings = 0;
    styleElement.kremlingAttr = kremlingAttr;
    styleElement.kremlingValue = kremlingValue;
    document.head.appendChild(styleElement);
    _styleElementUtils.styleTags[rawCss] = styleElement;
  }
  return styleElement;
}
//# sourceMappingURL=use-css.hook.js.map